// src/config/fontConfig.ts

/**
 * Centralized font configuration for the entire application
 * Change the font family here to apply it across all components
 */

export const APP_FONTS = {
  // Primary font used across the application
  primary: "'League Spartan', sans-serif",
  
  // Secondary fonts (if needed in the future)
  secondary: "'Inter', sans-serif",
  tertiary: "'Poppins', sans-serif",
} as const;

/**
 * Default font family to use in components
 * This is the main export that should be used throughout the app
 */
export const DEFAULT_FONT_FAMILY = APP_FONTS.primary;

/**
 * Font configuration object with common styles
 * Can be spread into component styles
 */
export const fontConfig = {
  fontFamily: DEFAULT_FONT_FAMILY,
} as const;

/**
 * Hook to get font family (optional, for React components)
 */
export const useFontFamily = () => {
  return DEFAULT_FONT_FAMILY;
};
